import { DestructiveButton, PrimaryButton } from 'ui/button';
import { Modal, MODAL_SIZES, ModalHeader, MODAL_VARIANTS, ModalBody, ModalFooter } from 'ui/modal';
import { ModalType, useModalContext } from 'modules/templateEditor/context';
import { displayContent } from '../../common/content';
import { CustomFontViewMode } from '../../common/types';

export const CONFIRM_CUSTOM_FONT_MODAL_TEST_ID = 'confirm-custom-font-modal';

export type ConfirmCustomFontModalProps = {
  mode: CustomFontViewMode;
  saveIsDisabled: boolean;
  onSaveCustomFont: () => void;
  onDeleteCustomFont: () => void;
};

export const ConfirmCustomFontModal = ({
  mode,
  saveIsDisabled,
  onSaveCustomFont,
  onDeleteCustomFont,
}: ConfirmCustomFontModalProps) => {
  const { closeModal } = useModalContext();

  return (
    <Modal
      isModalOpen
      withPortal
      id={CONFIRM_CUSTOM_FONT_MODAL_TEST_ID}
      onClose={() => closeModal(ModalType.ConfirmCustomFontModal)}
      data-test={CONFIRM_CUSTOM_FONT_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={mode === CustomFontViewMode.View ? MODAL_VARIANTS.DELETE : MODAL_VARIANTS.WARNING}
    >
      <ModalHeader autoFocus={false}>
        {mode === CustomFontViewMode.View
          ? displayContent.headerDeleteFont
          : displayContent.headerSaveFont}
      </ModalHeader>
      <ModalBody>
        {mode === CustomFontViewMode.View
          ? displayContent.strConfirmDeleteFont
          : displayContent.strConfirmEditFont}
      </ModalBody>
      <ModalFooter>
        {mode === CustomFontViewMode.View ? (
          <DestructiveButton onClick={() => onDeleteCustomFont()}>
            {displayContent.btnDeleteFont}
          </DestructiveButton>
        ) : (
          <PrimaryButton isDisabled={saveIsDisabled} onClick={() => onSaveCustomFont()}>
            {displayContent.btnSaveFont}
          </PrimaryButton>
        )}
      </ModalFooter>
    </Modal>
  );
};
